import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { disciplineAPI } from "../api";
import { getErrorMessage } from "../utils/apiError";
import { normalizeDisciplineSystem } from "../utils/discipline";
import { useAuth } from "./AuthContext";

const DisciplineSystemContext = createContext(null);

export function DisciplineSystemProvider({ children }) {
  const { user } = useAuth();
  const [disciplineSystem, setDisciplineSystem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchDisciplineSystem = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const data = await disciplineAPI.getDisciplineSystem();
      setDisciplineSystem(normalizeDisciplineSystem(data));
    } catch (err) {
      setDisciplineSystem(null);
      setError(getErrorMessage(err, "دریافت سیستم شایستگی های عمومی ناموفق بود"));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchDisciplineSystem();
      return;
    }

    setDisciplineSystem(null);
    setLoading(false);
    setError("");
  }, [user, fetchDisciplineSystem]);

  return (
    <DisciplineSystemContext.Provider
      value={{
        disciplineSystem,
        loading,
        error,
        refetch: fetchDisciplineSystem,
      }}
    >
      {children}
    </DisciplineSystemContext.Provider>
  );
}

export function useDisciplineSystem() {
  const context = useContext(DisciplineSystemContext);

  if (!context) {
    throw new Error("useDisciplineSystem must be used within DisciplineSystemProvider");
  }

  return context;
}
